import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { getProductDefaultInfo } from '../../../../utilities/selectors';
import {
  getZemplinProductDefaultInfo,
  getZemplinTrueCount,
  getElasticCategoryZemplinProductInfo,
  getPackagesString,
  resolveIsVykurovaciaOrPletiva,
} from '../../selectors';
import { OrderNrInput } from '../../Product/OrderNrInput';
import { TableRow } from '../../General/Table';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { CountSetter } from '../../ProductDetail/CountSetter';
import { __ } from 'react-i18n';
import {
  getSymbolFromCurrency,
  formatPriceToString,
  round,
  prop,
} from '../../../../utilities';
import { ModalMobileValue } from './ModalMobileValue';

export interface Props {
  product: any;
  theme: any;
  hasMinAmountInfo?: boolean;
  count: string;
  handleCountChange: any;
  isLoggedIn: any;
  isFromCategory?: boolean;
  isRequest?: boolean;
  noHandlingFee?: boolean;
}

function ModalItemMobile({
  product,
  theme,
  hasMinAmountInfo,
  count,
  handleCountChange,
  isLoggedIn,
  isFromCategory,
  isRequest,
  noHandlingFee,
}: Props) {
  const [isFocused, setIsFocused] = React.useState(false);

  const { currency } = getProductDefaultInfo(product);
  const {
    unit,
    price,
    priceWithoutVat,
    productPackages,
    unpackingCost,
    priceForUnpacking,
    unpackingCostWithoutVat,
    customerPrices,
    defaultPackageSize,
    wholePackagesOnly,
    onStock,
  } = isFromCategory
    ? getElasticCategoryZemplinProductInfo(product, isLoggedIn)
    : getZemplinProductDefaultInfo(product);

  // Ak mame kd sipozicii defaultnu hodnotu vlekosti balenia, pouzijeme ju
  const step = defaultPackageSize
    ? defaultPackageSize
    : productPackages
    ? productPackages
    : unit === 'Mks'
    ? 0.001
    : 1;

  const trueCount = unit === 'Mks' ? +count * 1000 : count;
  const correctPriceForUnpacking = priceForUnpacking ? priceForUnpacking : 5;

  let correctUnpackingCost = isLoggedIn
    ? unpackingCostWithoutVat
    : unpackingCost;
  correctUnpackingCost =
    correctPriceForUnpacking * +trueCount < 4 &&
    productPackages >= 0.026 &&
    productPackages > count &&
    correctUnpackingCost
      ? correctUnpackingCost * +trueCount
      : 0;
  const correctPrice = isLoggedIn ? priceWithoutVat : price;
  const totalPriceText = isLoggedIn ? __('Spolu bez DPH') : __('Spolu s DPH');
  let totalPrice = correctPrice ? +correctPrice * +count : '';
  const correctCustomerPrice = customerPrices
    ? customerPrices.find(cp => cp.quantity >= count)
    : null;
  if (correctCustomerPrice) {
    totalPrice = prop(correctCustomerPrice, 'unitprice') * +count;
  }

  const priceWithUnpacking = correctUnpackingCost + +totalPrice;
  const minimalPrice = isLoggedIn
    ? +priceWithUnpacking > 0.3
      ? priceWithUnpacking
      : '0.3'
    : +priceWithUnpacking > 0.3
    ? priceWithUnpacking
    : '0.36';

  const correctPerUnitPrice = !isFocused
    ? round(+minimalPrice / +count, 2)
    : '';

  const handleInputFocus = () => {
    setIsFocused(true);
  };

  const handleInputBlur = () => {
    setIsFocused(false);
  };

  const boxQuantity = prop(product, 'product_detail.main_good.box_quantity');
  const isVykurovaciaOrPletiva = resolveIsVykurovaciaOrPletiva(
    prop(product, 'product_detail'),
  );

  return (
    <Wrapper>
      <PriceValuesWrapper>
        <ModalMobileValue
          title={isLoggedIn ? __('Cena bez DPH') : __('Cena s DPH')}
          value={`${
            correctPerUnitPrice
              ? `${formatPriceToString(correctPerUnitPrice, currency)}`
              : ''
          }`}
        />
        <ModalMobileValue
          title={__('Balenie')}
          value={getPackagesString(
            defaultPackageSize ? defaultPackageSize : productPackages,
            unit,
          )}
        />
        {!!boxQuantity && (
          <ModalMobileValue
            title={
              isVykurovaciaOrPletiva
                ? __('Množstvo v balení')
                : __('Množstvo v kartóne')
            }
            value={getPackagesString(boxQuantity, unit)}
          />
        )}
        <CountWrapper>
          <CountSetter
            onChange={handleCountChange}
            unit={unit}
            count={count}
            step={step}
            handleInputFocus={handleInputFocus}
            handleInputBlur={handleInputBlur}
            wholePackagesOnly={wholePackagesOnly}
            onStock={onStock}
            noHandlingFee={noHandlingFee}
            defaultPackageSize={defaultPackageSize}
          />
        </CountWrapper>
        <ModalMobileValue
          title={totalPriceText}
          value={formatPriceToString(minimalPrice, currency)}
        />
      </PriceValuesWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(320)};
  margin: 0 auto;
  padding: ${rem(24)} 0 0;

  ${({ theme }) => theme.mediab.s450`
      max-width: initial;
      width: 100%;
  `}
`;

const CountWrapper = styled.div`
  margin-top: ${rem(8)};
  margin-bottom: ${rem(24)};
`;

const PriceValuesWrapper = styled(FlexCol)`
  margin-bottom: ${rem(16)};
`;

const WithTheme: any = withTheme(ModalItemMobile);
export { WithTheme as ModalItemMobile };
